import React from 'react';
import {getElementId, useWebformElement,} from 'gatsby-drupal-webform/dist/utils';
import WebformElementWrapper from './WebformElementWrapper';

export const WebformRadios = ({element, error}) => {
  const id = getElementId(element.name);
  const [inputProps, settings] = useWebformElement(element, {
    className: 'vl-input-field vl-input-field--block',
    name: element.name,
    type: element.type,
    id,
  });
  if (element.type === 'hidden') {
    return <input {...inputProps} />;
  }

  let defaultValue = '';
  element.attributes.forEach((attribute) => {
    if (attribute.name == '#default_value') {
      defaultValue = attribute.value;
      return;
    }
  });


  return (
    <WebformElementWrapper
      labelClassName="vl-form__label vl-form__label--light"
      settings={settings}
      error={error}
      labelFor={id}
    >
      {element.options.map((option, index) => {
        return (
          <label key={index} className="vl-radio" htmlFor={`${element.name}-radio-${index}`}>
            <input
              className="vl-radio__toggle"
              type="radio"
              id={`${element.name}-radio-${index}`}
              name={element.name}
              value={option.value}
              defaultChecked={option.value == defaultValue}
            />
            <div className="vl-radio__label">{option.label}</div>
          </label>
        );
      })}
    </WebformElementWrapper>
  );
};

export default WebformRadios;
